function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import G6 from '@antv/g6';
import registerFn from '@/components/lineage/components/g6_cnode.mjs';
import { mapState, mapMutations } from 'vuex';
import utils from '@/js/utils';
import { LIST_ROLES, LIST_DOMAINS, ROLES_LIST } from '@/js/constants';
import tasks from '@/js/tasks';
import mlops_service from '@/apps/analytic-services/services/mlops_service';
import DialogsComponent from '../../../../components/DialogsComponent.vue';
import CustomComponentsMlops from '../../components/CustomComponentsMlops.vue';
import img_vertex_component from '@/assets/vertex-component.png';
import img_vertex_email from '@/assets/vertex-email.png';
import img_vertex_error from '@/assets/vertex-error.png';
import img_vertex_ok from '@/assets/vertex-ok.png';
import img_vertex_tree from '@/assets/vertex-tree.png';
import img_vertex_default from '@/assets/vertex-default.png';
var ICON_MAP = {
  icon_component: img_vertex_component,
  icon_default: img_vertex_default,
  icon_email: img_vertex_email,
  icon_ok: img_vertex_ok,
  icon_error: img_vertex_error,
  icon_tree: img_vertex_tree
};
export default {
  components: {
    DialogsComponent: DialogsComponent,
    CustomComponentsMlops: CustomComponentsMlops
  },
  data: function data() {
    return {
      isChecked: true,
      componentes: [],
      dates: [],
      dates2: [],
      componentes_to_filters: [],
      key_table: 1,
      pagination: {
        current: 1,
        total: 0,
        sort_by: ['created_date_desc'],
        sort_desc: [true]
      },
      filter_enabled: true,
      types: [{
        value: 'vertex_pipelines',
        text: 'VERTEX PIPELINE'
      }
      //{ value: 'bigquery_datasets', text: 'BIGQUERY DATASET' },
      //{ value: 'bigquery_tables', text: 'BIGQUERY TABLE' },
      ],
      menu2: false,
      item_selected: null,
      headers_executions: [{
        text: 'JOB ID',
        value: 'id'
      }, {
        text: 'Fecha de Creación',
        value: 'created_time_desc'
      }, {
        text: 'Estado',
        value: 'state_name'
      }, {
        text: 'Ejecutor',
        value: 'user_auth'
      }, {
        text: 'Acciones',
        value: 'actions'
      }],
      executions: [],
      pagination_executions: {
        current: 1,
        total: 0,
        sort_by: ['created_time_desc'],
        sort_desc: [true]
      },
      key_table_executions: 1,
      headers_permissions: [{
        text: 'Usuario',
        value: 'user',
        class: "w-35"
      }, {
        text: 'Ver',
        value: 'view',
        class: "w-10"
      }, {
        text: 'Ejecución',
        value: 'execute',
        class: "w-55"
      }],
      pagination_permissions: {
        current: 1,
        total: 0,
        sort_by: [],
        sort_desc: []
      },
      permissions: [],
      key_table_permissions: 1,
      parameters_execute: {},
      detail_execution: {
        "id": "dev-itcm-demo2-vtx-demo2-j20230913153016",
        "state_name": "PIPELINE_STATE_FAILED",
        "name": "dev-itcm-demo2-vtx-demo2-j20230913153016",
        "display_name": "demo2",
        "state": 5,
        "resource_name": "projects/573771604679/locations/us-central1/pipelineJobs/dev-itcm-demo2-vtx-demo2-j20230913153016",
        "create_time": "2023-09-13T20:30:17.905954+00:00",
        "update_time": "2023-09-13T20:33:48.776815+00:00",
        "location": "us-central1",
        "has_failed": true,
        "labels": {
          "company": "dataoffice",
          "environment": "dev",
          "vertex-ai-pipelines-run-billing-id": "8531510392390680576",
          "owner": "luis-aybar",
          "chapter": "ml",
          "module": "demo1",
          "application": "demo"
        },
        "tasks": [{
          "task_id": -7649779994800947200,
          "parent_task_id": 2321189580197330944,
          "task_name": "condition-execute-3",
          "job_id": "",
          "state": 9,
          "state_name": "NOT_TRIGGERED",
          "start_time": "2023-09-13T20:32:04.632319+00:00",
          "start_time_f": "2023-09-13T20:32:04.632319Z",
          "end_time": "2023-09-13T20:32:04.632319+00:00",
          "end_time_f": "2023-09-13T20:32:04.632319Z",
          "execution": {
            "display_name": "condition-execute-3",
            "description": "",
            "name": "projects/573771604679/locations/us-central1/metadataStores/default/executions/16215388297446346981",
            "schema_title": "system.DagExecution",
            "state": 3,
            "state_name": "COMPLETE",
            "metadata_items": [{
              "key": "input:pipelineparam--project",
              "value": "string_value: \"dev-intercorp-data-operation\"\n"
            }, {
              "key": "input:pipelineparam--workclass",
              "value": "string_value: \"Private\"\n"
            }, {
              "key": "input:pipelineparam--occupation",
              "value": "string_value: \"Undetermined\"\n"
            }, {
              "key": "input:pipelineparam--mlops-validation-bigquery-tables-condition",
              "value": "string_value: \"false\"\n"
            }, {
              "key": "input:pipelineparam--native_country",
              "value": "string_value: \"United States\"\n"
            }]
          }
        }, {
          "task_id": -7577722400763019264,
          "parent_task_id": 6185278060481216512,
          "task_name": "error-op",
          "job_id": "6847376131339845632",
          "state": 7,
          "state_name": "FAILED",
          "start_time": "2023-09-13T20:32:05.047099+00:00",
          "start_time_f": "2023-09-13T20:32:05.047099Z",
          "end_time": "2023-09-13T20:33:47.386043+00:00",
          "end_time_f": "2023-09-13T20:33:47.386043Z",
          "execution": {
            "display_name": "error-op",
            "description": "",
            "name": "projects/573771604679/locations/us-central1/metadataStores/default/executions/17967515763431445640",
            "schema_title": "system.ContainerExecution",
            "state": 4,
            "state_name": "FAILED",
            "metadata_items": [{
              "key": "input:msg",
              "value": "string_value: \"No se logro validar las tablas de ingesta.\"\n"
            }]
          }
        }, {
          "task_id": -6902182456657444864,
          "parent_task_id": 780958507636621312,
          "task_name": "vertex-pipelines-notification-email",
          "job_id": "",
          "state": 3,
          "state_name": "SUCCEEDED",
          "start_time": "2023-09-13T20:33:48.282222+00:00",
          "start_time_f": "2023-09-13T20:33:48.282222Z",
          "end_time": "2023-09-13T20:33:48.540639+00:00",
          "end_time_f": "2023-09-13T20:33:48.540639Z",
          "execution": {
            "display_name": "vertex-pipelines-notification-email",
            "description": "",
            "name": "projects/573771604679/locations/us-central1/metadataStores/default/executions/13125626859004749186",
            "schema_title": "system.ContainerExecution",
            "state": 3,
            "state_name": "COMPLETE",
            "metadata_items": [{
              "key": "input:pipeline_task_final_status",
              "value": "string_value: \"{\\\"error\\\":{\\\"code\\\":9,\\\"message\\\":\\\"The DAG failed because some tasks failed. The failed tasks are: [condition-no-execute-2].\\\"},\\\"pipelineJobResourceName\\\":\\\"projects/573771604679/locations/us-central1/pipelineJobs/dev-itcm-demo2-vtx-demo2-j20230913153016\\\",\\\"pipelineTaskName\\\":\\\"Execute [demo2]\\\",\\\"state\\\":\\\"FAILED\\\"}\"\n"
            }, {
              "key": "input:recipients",
              "value": "string_value: \"[\\\"laybarm@intercorp.com.pe\\\"]\"\n"
            }]
          }
        }, {
          "task_id": -3038093976373559296,
          "parent_task_id": 2321189580197330944,
          "task_name": "mlops-validation-bigquery-tables",
          "job_id": "751191085740457984",
          "state": 3,
          "state_name": "SUCCEEDED",
          "start_time": "2023-09-13T20:30:21.448098+00:00",
          "start_time_f": "2023-09-13T20:30:21.448098Z",
          "end_time": "2023-09-13T20:32:04.273313+00:00",
          "end_time_f": "2023-09-13T20:32:04.273313Z",
          "execution": {
            "display_name": "mlops-validation-bigquery-tables",
            "description": "",
            "name": "projects/573771604679/locations/us-central1/metadataStores/default/executions/1226402631593296850",
            "schema_title": "system.ContainerExecution",
            "state": 3,
            "state_name": "COMPLETE",
            "metadata_items": [{
              "key": "vertex-ai-pipelines-artifact-argument-binding",
              "value": "struct_value {\n  fields {\n    key: \"output:html_artifact\"\n    value {\n      list_value {\n        values {\n          string_value: \"projects/573771604679/locations/us-central1/metadataStores/default/artifacts/10284782353590401130\"\n        }\n      }\n    }\n  }\n}\n"
            }, {
              "key": "input:data_text",
              "value": "string_value: \"[{\\\"project_id\\\": \\\"int-advanced-analytics-01\\\", \\\"dataset\\\": \\\"expl_research_laybarm\\\", \\\"table\\\": \\\"CENSUS\\\", \\\"columns\\\": null, \\\"query\\\": null}]\"\n"
            }, {
              "key": "input:bq_location",
              "value": "string_value: \"US\"\n"
            }, {
              "key": "input:bq_client_project_id",
              "value": "string_value: \"dev-intercorp-data-operation\"\n"
            }, {
              "key": "output:condition",
              "value": "string_value: \"false\"\n"
            }]
          }
        }, {
          "task_id": 780958507636621312,
          "parent_task_id": 0,
          "task_name": "dev-itcm-demo2-vtx-demo2-j20230913153016",
          "job_id": "",
          "state": 7,
          "state_name": "FAILED",
          "start_time": "2023-09-13T20:30:20.146111+00:00",
          "start_time_f": "2023-09-13T20:30:20.146111Z",
          "end_time": "2023-09-13T20:33:48.763731+00:00",
          "end_time_f": "2023-09-13T20:33:48.763731Z",
          "execution": {
            "display_name": "dev-itcm-demo2-vtx-demo2-j20230913153016",
            "description": "",
            "name": "projects/573771604679/locations/us-central1/metadataStores/default/executions/15879173872254336815",
            "schema_title": "system.Run",
            "state": 4,
            "state_name": "FAILED",
            "metadata_items": [{
              "key": "input:workclass",
              "value": "string_value: \"Private\"\n"
            }, {
              "key": "input:occupation",
              "value": "string_value: \"Undetermined\"\n"
            }, {
              "key": "input:project",
              "value": "string_value: \"dev-intercorp-data-operation\"\n"
            }, {
              "key": "input:gcp_region",
              "value": "string_value: \"us-central1\"\n"
            }, {
              "key": "input:creation_user",
              "value": "string_value: \"dev-itcbi-mlop-process-app@dev-intercorp-data-operation.iam.gserviceaccount.com\"\n"
            }, {
              "key": "input:native_country",
              "value": "string_value: \"United States\"\n"
            }]
          }
        }, {
          "task_id": 2321189580197330944,
          "parent_task_id": 780958507636621312,
          "task_name": "exit-handler-1",
          "job_id": "",
          "state": 7,
          "state_name": "FAILED",
          "start_time": "2023-09-13T20:30:20.492095+00:00",
          "start_time_f": "2023-09-13T20:30:20.492095Z",
          "end_time": "2023-09-13T20:33:47.892925+00:00",
          "end_time_f": "2023-09-13T20:33:47.892925Z",
          "execution": {
            "display_name": "exit-handler-1",
            "description": "",
            "name": "projects/573771604679/locations/us-central1/metadataStores/default/executions/15897627734833327822",
            "schema_title": "system.DagExecution",
            "state": 4,
            "state_name": "FAILED",
            "metadata_items": [{
              "key": "input:pipelineparam--project",
              "value": "string_value: \"dev-intercorp-data-operation\"\n"
            }, {
              "key": "input:pipelineparam--workclass",
              "value": "string_value: \"Private\"\n"
            }, {
              "key": "input:pipelineparam--native_country",
              "value": "string_value: \"United States\"\n"
            }, {
              "key": "input:pipelineparam--occupation",
              "value": "string_value: \"Undetermined\"\n"
            }]
          }
        }, {
          "task_id": 6185278060481216512,
          "parent_task_id": 2321189580197330944,
          "task_name": "condition-no-execute-2",
          "job_id": "",
          "state": 7,
          "state_name": "FAILED",
          "start_time": "2023-09-13T20:32:04.637455+00:00",
          "start_time_f": "2023-09-13T20:32:04.637455Z",
          "end_time": "2023-09-13T20:33:47.661064+00:00",
          "end_time_f": "2023-09-13T20:33:47.661064Z",
          "execution": {
            "display_name": "condition-no-execute-2",
            "description": "",
            "name": "projects/573771604679/locations/us-central1/metadataStores/default/executions/13608664118101640706",
            "schema_title": "system.DagExecution",
            "state": 4,
            "state_name": "FAILED",
            "metadata_items": [{
              "key": "input:pipelineparam--mlops-validation-bigquery-tables-condition",
              "value": "string_value: \"false\"\n"
            }]
          }
        }]
      },
      detail_node: null,
      execution_logs: [],
      graph: null,
      see_detail: false,
      key_table_logs: 1,
      filters: {}
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('analytic-services', ['has_mlops_active'])), {}, {
    getClassTable: function getClassTable() {
      if (this.filter_enabled) return 'col-md-9 col-sm-12';else return 'col-sm-12';
    },
    headers: function headers() {
      return [{
        text: 'ID',
        value: 'id'
      }, {
        text: this.traductor('tabla_componentes.name'),
        value: 'name'
      }, {
        text: this.traductor('tabla_componentes.type'),
        value: 'type',
        align: "center"
      }, {
        text: this.traductor('tabla_componentes.created_date'),
        value: 'created_date_desc',
        align: "center"
      }, {
        text: this.traductor('tabla_componentes.user_created'),
        value: 'applicant',
        align: "center"
      }, {
        text: this.traductor('tabla_componentes.actions'),
        value: 'acciones',
        align: "left",
        class: "w-15"
      }];
    },
    filtros: function filtros() {
      return {
        name: this.traductor('tabla_componentes.name'),
        type: this.traductor('tabla_componentes.type'),
        status: this.traductor('tabla_componentes.status'),
        rango: 'Fecha Creación'
      };
    },
    dateRangeText: function dateRangeText() {
      return this.filters.fechas ? this.filters.fechas.join(' ~ ') : '';
    }
  }),
  created: function created() {
    if (!this.has_mlops_active) {
      this.$router.push({
        name: 'HomePage'
      });
      return;
    }
    this.onLimpiar();
  },
  methods: {
    onLimpiarFiltroFecha: function onLimpiarFiltroFecha() {
      this.filters.fechas = [];
      this.menu2 = false;
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    formatDateLast: function formatDateLast(data) {
      return data ? data.substring(0, 19).replace("T", " ") : '';
    },
    onLimpiar: function onLimpiar() {
      this.componentes = Object.assign([], this.componentes_to_filters);
      this.resetFilters();
      this.componentes = [];
      this.getComponentes();
    },
    resetFilters: function resetFilters() {
      this.filters = {
        type: "vertex_pipelines"
      };
    },
    getComponentes: function getComponentes() {
      var _this = this;
      var datos = {
        filters: this.filters
      };
      mlops_service.getComponents(datos).then(function (response) {
        console.log(response);
        _this.componentes = response.data;
        _this.componentes.filter(function (z) {
          if (_this.filters.type == 'vertex_pipelines') {
            z.type = "VERTEX PIPELINE";
          }
        });
        _this.componentes_to_filters = Object.assign([], response.data);
        _this.key_table += 1;
      });
    },
    onSearch: function onSearch() {
      var _this2 = this;
      this.componentes = Object.assign([], this.componentes_to_filters);
      if (this.filters.name) {
        this.componentes = this.componentes.filter(function (x) {
          return x.name && x.name.toUpperCase().indexOf(_this2.filters.name.toUpperCase()) != -1;
        });
      }
      if (this.filters.fechas) {
        if (_typeof(this.filters.fechas) === "object") {
          if (this.filters.fechas.length > 1) {
            this.componentes = this.componentes.filter(function (x) {
              return x.created_date_desc.substring(0, 10) >= _this2.filters.fechas[0] && x.created_date_desc.substring(0, 10) <= _this2.filters.fechas[1] || x.created_date_desc.substring(0, 10) >= _this2.filters.fechas[1] && x.created_date_desc.substring(0, 10) <= _this2.filters.fechas[0];
            });
          } else if (this.filters.fechas.length == 1) {
            this.componentes = this.componentes.filter(function (x) {
              return x.created_date_desc.substring(0, 10) >= _this2.filters.fechas[0] && x.created_date_desc.substring(0, 10) <= _this2.filters.fechas[0];
            });
          }
        }
      }
    },
    onChangeType: function onChangeType(event) {
      this.getComponentes();
    },
    executePipeline: function executePipeline(item) {
      var _this3 = this;
      this.item_selected = item;
      this.parameters_execute = Object.assign({}, {});
      this.item_selected.parameters.forEach(function (element) {
        _this3.parameters_execute[element.name] = element.default;
      });
      this.$refs["MODAL_CONFIRM_EXECUTE"].onOpen();
    },
    onConfirmExecutePipeline: function onConfirmExecutePipeline(event) {
      var _this4 = this;
      console.log(this.parameters_execute);
      if (event) {
        mlops_service.executePipeline(this.item_selected.request_id, this.item_selected.id, this.parameters_execute).then(function (response) {
          _this4.$refs["MODAL_CONFIRM_EXECUTE"].onClose();
          if (response.success) {
            tasks.toast.success("Se ha iniciado la ejecución con ID: " + response.data + ", puede ver el detalle en la sección de acciones.");
            _this4.getComponentes();
          } else {
            tasks.toast.error("No se ha podido iniciar la ejecución, intentelo en unos minutos.");
          }
        });
      } else {
        this.$refs["MODAL_CONFIRM_EXECUTE"].onClose();
      }
    },
    onOpenListExecution: function onOpenListExecution(item) {
      this.item_selected = item;
      this.$refs["MODAL_LIST_EXECUTIONS"].onOpen();
      this.listExecutions();
    },
    onOpenShareComponent: function onOpenShareComponent(item) {
      this.item_selected = item;
      this.permissions = item.permissions ? Object.assign([], item.permissions) : [];
      this.$refs["MODAL_LIST_PERMISSIONS"].onOpen();
    },
    listExecutions: function listExecutions() {
      var _this5 = this;
      this.see_detail = false;
      mlops_service.listExecutions(this.item_selected.id).then(function (response) {
        if (response.success) {
          _this5.executions = response.data;
          _this5.pagination_executions.total = _this5.executions.itemsLength;
          _this5.onRenderPipeline();
        }
      });
    },
    onPingExecution: function onPingExecution(item) {
      var _this6 = this;
      mlops_service.pingExecution(this.item_selected.id, item.id).then(function (response) {
        if (response.success) {
          _this6.listExecutions();
        }
      });
    },
    onSeeDetail: function onSeeDetail() {
      this.see_detail = !this.see_detail;
    },
    onViewDetailExecution: function onViewDetailExecution(item) {
      var _this7 = this;
      if (item.state_name) {
        this.see_detail = true;
        setTimeout(function () {
          _this7.detail_execution = Object.assign({}, item);
          _this7.detail_node = null;
          if (_this7.detail_execution.tasks) _this7.onRenderPipeline();
        }, 500);
      }
    },
    prepareDataRender: function prepareDataRender() {
      var data = {
        nodes: [],
        edges: []
      };
      this.detail_execution.tasks.forEach(function (task) {
        var item = {
          id: "" + task.task_id + "",
          title: task.task_name,
          error: task.execution.state == 4,
          default: task.state == 9,
          nodeType: 'a',
          nodeLevel: 3,
          description: "",
          type: 'custom-node',
          name: task.task_name
        };
        data.nodes.push(item);
        if (task.parent_task_id != 0) {
          var edge = {
            source: "" + task.parent_task_id + "",
            target: "" + task.task_id + ""
          };
          data.edges.push(edge);
        }
      });
      return data;
    },
    onRenderPipeline: function onRenderPipeline() {
      var _this8 = this;
      G6.registerNode('custom-node', {
        draw: function draw(cfg, group) {
          var color_backgroud = cfg.error && !cfg.default ? '#fce8e6' : cfg.default ? '#f0f0f0' : '#e6f4ea';
          var icon_state = cfg.error ? 'icon_error' : cfg.default ? 'icon_default' : 'icon_ok';
          var icon_mode = 'icon_component';
          var width = 400; // Width of the node
          var height = 60; // Height of the node
          var padding = 0; // Padding between columns
          var radius = 5;

          // Create the outer rectangle representing the node
          var rect1 = group.addShape('rect', {
            attrs: {
              x: -200,
              y: 0,
              width: 400,
              height: 60,
              fill: 'white',
              stroke: '#d4d9da',
              radius: 5,
              shadowColor: 'rgba(0, 0, 0, 0.3)',
              // Shadow color
              shadowBlur: 10,
              // Shadow blur
              shadowOffsetX: 5,
              // Shadow offset in the X direction
              shadowOffsetY: 5,
              // Shadow offset in the Y direction
              cursor: 'pointer'
            }
          });
          group.addShape('rect', {
            attrs: {
              x: padding - 200,
              y: padding,
              width: (width - 3 * padding) * 0.1,
              // Divide the width into two columns
              height: height - 2 * padding,
              fill: 'white',
              radius: [radius, 0, 0, radius],
              cursor: 'pointer'
            }
          });
          // Create the first rectangle representing the first column
          group.addShape('rect', {
            attrs: {
              x: (width + padding) * 0.1 - 200,
              y: padding,
              width: (width - 3 * padding) * 0.75,
              // Divide the width into two columns
              height: height - 2 * padding,
              fill: 'white',
              cursor: 'pointer'
            }
          });

          // Create the second rectangle representing the second column
          group.addShape('rect', {
            attrs: {
              x: (width + padding) * 0.85 - 200,
              y: padding,
              width: (width - 3 * padding) * 0.15,
              // Divide the width into two columns
              height: height - 2 * padding,
              fill: color_backgroud,
              radius: [0, radius, radius, 0],
              cursor: 'pointer'
            }
          });
          group.addShape('image', {
            attrs: {
              x: 15 - 200,
              y: 17,
              height: 25,
              width: 25,
              cursor: 'pointer',
              img: ICON_MAP[icon_mode || 'app']
            },
            name: 'node-icon'
          });

          // title text
          group.addShape('text', {
            attrs: {
              textBaseline: 'top',
              y: 15,
              x: 55 - 200,
              lineHeight: 20,
              text: cfg.title.length > 46 ? cfg.title.substring(0, 46) + " ..." : cfg.title,
              fill: '#3c4043',
              cursor: 'pointer'
            },
            name: 'title'
          });

          // The content list
          // name text
          group.addShape('text', {
            attrs: {
              textBaseline: 'top',
              y: 35,
              x: 55 - 200,
              lineHeight: 20,
              text: cfg.description.length > 46 ? cfg.description.substring(0, 46) + " ..." : cfg.description,
              fill: 'rgba(0,0,0, 0.4)',
              cursor: 'pointer'
            },
            name: "index-title-".concat(0)
          });
          group.addShape('image', {
            attrs: {
              x: 355 - 200,
              y: 15,
              height: 30,
              width: 30,
              cursor: 'pointer',
              img: ICON_MAP[icon_state || 'app']
            },
            name: 'node-icon'
          });
          return rect1;
        }
      }, 'single-node');
      var container = document.getElementById('container');
      var width = container.scrollWidth;
      var height = container.scrollHeight || 500;
      /*
      const data = {
        nodes: [
          {
            id: '1',
            title: 'Ejecucion de Pipeline',
            error: true,
            nodeType: 'a',
            nodeLevel: 3,
            description: "Hola Mundo",
            type: 'custom-node',
            name: 'alps_file2asdasd'
          },
          {
            id: '2',
            title: 'Ejecucion de Pipeline',
            error: false,
            nodeType: 'a',
            nodeLevel: 2,
            description: "Hola Mundo",
            dataType: 'alps',
            type: 'custom-node',
            
          },
          {
            id: '3',
            title: 'Ejecucion de Pipeline',
            error: false,
            default: true,
            nodeType: 'a',
            nodeLevel: 2,
            description: "Hola Mundo",
            type: 'custom-node',
            dataType: 'alps',
            name: 'alps_file3',
          },
          {
            id: '4',
            title: 'Ejecucion de Pipeline',
            error: true,
            nodeType: 'a',
            nodeLevel: 2,
            description: "Hola Mundo",
            dataType: 'alps',
            type: 'custom-node',
            dataType: 'sql',
            name: 'sql_file1',
          },
          {
            id: '5',
            title: 'Ejecucion de Pipeline',
            error: true,
            nodeType: 'a',
            nodeLevel: 2,
            description: "Hola Mundo",
            dataType: 'alps',
            type: 'custom-node',
            dataType: 'sql',
            name: 'sql_file2'
          },
          {
            id: '6',
            title: 'Ejecucion de Pipeline',
            error: true,
            nodeType: 'a',
            nodeLevel: 2,
            description: "Hola Mundo",
            dataType: 'alps',
            type: 'custom-node',
            dataType: 'feature_etl',
            name: 'feature_etl_1'
          },
          {
            id: '7',
            title: 'Ejecucion de Pipeline',
            error: true,
            nodeType: 'a',
            nodeLevel: 2,
            description: "Hola Mundo",
            dataType: 'alps',
            type: 'custom-node',
            dataType: 'feature_etl',
            name: 'feature_etl_1'
          },
          {
            id: '8',
            title: 'Ejecucion de Pipeline',
            error: true,
            nodeType: 'a',
            nodeLevel: 2,
            description: "Hola Mundo",
            dataType: 'alps',
            type: 'custom-node',
            dataType: 'feature_extractor',
            name: 'feature_extractor'
          },
        ],
        edges: [
          {
            source: '1',
            target: '2',
          },
          {
            source: '1',
            target: '7',
          },
          {
            source: '1',
            target: '3',
          },
          {
            source: '2',
            target: '4',
          },
          {
            source: '3',
            target: '4',
          },
          {
            source: '4',
            target: '5',
          },
          {
            source: '5',
            target: '6',
          },
          {
            source: '6',
            target: '7',
          },
          {
            source: '6',
            target: '8',
          },
        ],
      };*/
      var data = this.prepareDataRender();
      if (this.graph) {
        //this.graph.changeData(data);
        this.graph.destroy();
        this.graph = null;
      }
      //else {
      this.graph = new G6.Graph({
        container: 'container',
        width: width,
        height: height,
        layout: {
          type: 'dagre',
          nodesepFunc: function nodesepFunc(d) {
            if (d.id === '3') {
              return 500;
            }
            return 200;
          },
          ranksep: 50,
          controlPoints: true
        },
        defaultNode: {
          type: 'my-rect'
        },
        defaultEdge: {
          type: 'polyline',
          style: {
            radius: 400,
            offset: 1,
            endArrow: true,
            lineWidth: 1,
            stroke: '#C2C8D5'
          }
        },
        nodeStateStyles: {
          selected: {
            stroke: '#3b78e7',
            fill: 'white',
            lineWidth: 5
          }
        },
        modes: {
          default: ['drag-canvas', 'zoom-canvas', 'click-select']
        },
        fitView: true
      });
      this.graph.data(data);
      this.graph.render();
      this.graph.on('node:click', function (evt) {
        var node = evt.item.getModel();
        _this8.handleNodeClick(node);
      });
      //}
    },
    handleNodeClick: function handleNodeClick(item) {
      console.log(item);
      var items = this.detail_execution.tasks.filter(function (x) {
        return "" + x.task_id + "" == item.id;
      });
      if (items.length > 0) {
        this.detail_node = items[0];
      }
    },
    onDownloadLog: function onDownloadLog(detail_node, file) {
      var _this9 = this;
      if (detail_node.execution_logs) return;
      var data = {
        "domain": "",
        "config_id": this.item_selected.config_id,
        "log_file": file
      };
      mlops_service.onDownloadLog(data).then(function (response) {
        if (response.success) {
          detail_node.execution_logs = response.data;
          _this9.key_table_logs += 1;
        }
      });
    },
    onAgregarPermission: function onAgregarPermission() {
      this.permissions.push({});
      this.key_table_permissions += 1;
    },
    onGuardarPermissions: function onGuardarPermissions() {
      var _this0 = this;
      console.log(this.permissions);
      var data = {
        id: this.item_selected.id,
        permissions: this.permissions
      };
      mlops_service.onGuardarPermissions(data).then(function (response) {
        if (response.success) {
          tasks.toast.success("Se ha guardado los permisos correctamente.");
          _this0.$refs["MODAL_LIST_PERMISSIONS"].onClose();
          _this0.getComponentes();
        } else {
          tasks.toast.error("No se pudo guardar los permisos.");
        }
      });
    },
    onOpenApiDoc: function onOpenApiDoc() {
      var url = process.env.VUE_APP_API_GTW + "/mlops/web/apidocs";
      window.open(url, '_blank');
    }
  }
};